import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SingleSignonApiService {

  readonly url = 'security/authenticate/';

  constructor(private http: HttpClient) {
  }

  public authenticateUserByToken(token): Promise<any> {
    return this.http.get(this.url + token).toPromise();
  }

}
